import { Link } from 'react-router-dom'
import '../SASS/contact.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import SocialLink from '../components/SocialLink'

const Contact = () => {
  const refForm = useRef()

  const sendEmail = (e) => {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_sz6s13m',
        'template_7oe509h',
        refForm.current,
        'xvVMqXY1DKEFAjurd'
      )
      .then(
        (result) => {
          console.log(result.text)
        },
        (error) => {
          console.log(error.text)
        }
      )
  }

  return (
    <section className="contact-container">
      <div className="home-link">
        <Link to="/">
          Home
          <FontAwesomeIcon icon={faArrowRight} />
        </Link>
        <div className="line"></div>
        <span>&copy;/2022</span>
      </div>
      <article>
        <div className="text-content">
          <h2>Get in touch</h2>
          <p className="pera">
            Thanks for taking the time to reach out. How can I help you today?
          </p>
          <p className="email">
            Email:{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="mailto:tehseen.type@gmail.com"
            >
              tehseen.type@gmail.com
            </a>
          </p>
        </div>
        <div className="contact-form">
          <h3>Say hello.</h3>
          <form autoComplete="off" ref={refForm} onSubmit={sendEmail}>
            <div className="two-col">
              <div className="name-feild half">
                <input type="text" name="name" placeholder="Name" required />
              </div>
              <div className="email-feild half">
                <input type="email" name="email" placeholder="Email" required />
              </div>
            </div>
            <div className="subect-feild">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                required
              />
            </div>
            <div className="message-feild">
              <textarea
                type="text"
                name="message"
                placeholder="Message"
                required
              />
            </div>
            <div className="submit">
              <input
                type="submit"
                value="Send Message!"
                className="submit-btn"
              />
            </div>
          </form>
        </div>
      </article>
      <div className="right-fixed">
        <SocialLink />
      </div>
      <div className="contact-svg">
        <svg
          width="1245"
          height="188"
          viewBox="0 0 1245 188"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M173.304 66.8359H134.952C135.07 61.746 134.419 57.2479 132.999 53.3416C131.578 49.3762 129.447 46.0026 126.607 43.2209C123.825 40.4392 120.422 38.3381 116.397 36.9176C112.372 35.438 107.845 34.6982 102.814 34.6982C93.1075 34.6982 84.2001 37.1248 76.0916 41.978C67.9832 46.8312 61.1473 53.8743 55.5838 63.1072C50.0204 72.281 46.1733 83.3783 44.0426 96.3991C41.9711 108.946 42.0895 119.452 44.3977 127.915C46.706 136.379 50.7898 142.771 56.6491 147.092C62.5677 151.353 69.9363 153.484 78.755 153.484C84.2 153.484 89.3788 152.803 94.2912 151.442C99.2036 150.021 103.672 148.009 107.697 145.405C111.781 142.741 115.332 139.516 118.35 135.728C121.428 131.94 123.825 127.649 125.541 122.855H164.16C161.733 131.2 157.945 139.25 152.796 147.003C147.706 154.756 141.403 161.681 133.886 167.777C126.37 173.814 117.817 178.608 108.229 182.159C98.6413 185.71 88.1359 187.486 76.7131 187.486C60.2003 187.486 46.0253 183.698 34.1882 176.122C22.4103 168.546 13.9171 157.627 8.70881 143.363C3.50047 129.099 2.52391 111.906 5.77912 91.7827C9.03433 72.3106 15.3968 55.7978 24.8665 42.2443C34.3954 28.6316 45.9661 18.3037 59.5788 11.2606C73.2507 4.21756 87.8696 0.696016 103.435 0.696016C114.266 0.696016 124.062 2.17566 132.821 5.13494C141.58 8.09422 149.038 12.4148 155.193 18.0966C161.408 23.7192 166.083 30.6143 169.22 38.782C172.357 46.9496 173.718 56.3009 173.304 66.8359ZM363.245 96.5767C359.931 115.99 353.509 132.473 343.98 146.026C334.511 159.58 322.94 169.878 309.268 176.921C295.655 183.964 280.977 187.486 265.234 187.486C248.721 187.486 234.487 183.728 222.532 176.211C210.635 168.694 202.024 157.834 196.697 143.629C191.37 129.366 190.364 112.172 193.679 92.049C196.875 72.5769 203.237 56.0642 212.766 42.5107C222.295 28.898 233.925 18.5405 247.656 11.4382C261.387 4.27675 276.154 0.696016 291.956 0.696016C308.351 0.696016 322.496 4.4839 334.392 12.0597C346.348 19.6354 354.959 30.5848 360.227 44.9077C365.554 59.1714 366.56 76.3944 363.245 96.5767ZM324.982 92.049C327.053 79.5608 326.965 69.085 324.716 60.6214C322.526 52.0987 318.501 45.6475 312.642 41.2678C306.782 36.888 299.384 34.6982 290.447 34.6982C280.741 34.6982 271.833 37.1248 263.725 41.978C255.676 46.8312 248.869 53.8743 243.306 63.1072C237.801 72.281 233.984 83.4375 231.853 96.5767C229.723 109.124 229.782 119.6 232.031 128.004C234.339 136.409 238.453 142.771 244.371 147.092C250.349 151.353 257.777 153.484 266.654 153.484C276.302 153.484 285.12 151.116 293.11 146.381C301.16 141.587 307.936 134.633 313.441 125.518C318.945 116.345 322.792 105.188 324.982 92.049ZM559.246 3.18181L529.061 185H495.858L435.933 70.5646H434.512L415.425 185H376.984L407.169 3.18181H440.904L500.563 117.528H502.073L520.982 3.18181H559.246ZM578.755 34.8757L584.082 3.18181H733.407L728.08 34.8757H672.416L647.558 185H609.561L634.419 34.8757H578.755ZM736.936 185H695.743L788.694 3.18181H838.232L870.725 185H829.532L807.426 44.7301H806.006L736.936 185ZM746.346 113.533H843.648L838.498 143.54H741.197L746.346 113.533ZM1063.93 66.8359H1025.58C1025.7 61.746 1025.04 57.2479 1023.62 53.3416C1022.2 49.3762 1020.07 46.0026 1017.23 43.2209C1014.45 40.4392 1011.05 38.3381 1007.02 36.9176C1003 35.438 998.47 34.6982 993.439 34.6982C983.732 34.6982 974.825 37.1248 966.717 41.978C958.608 46.8312 951.772 53.8743 946.209 63.1072C940.645 72.281 936.798 83.3783 934.668 96.3991C932.596 108.946 932.714 119.452 935.023 127.915C937.331 136.379 941.415 142.771 947.274 147.092C953.193 151.353 960.561 153.484 969.38 153.484C974.825 153.484 980.004 152.803 984.916 151.442C989.829 150.021 994.297 148.009 998.322 145.405C1002.41 142.741 1005.96 139.516 1008.98 135.728C1012.05 131.94 1014.45 127.649 1016.17 122.855H1054.78C1052.36 131.2 1048.57 139.25 1043.42 147.003C1038.33 154.756 1032.03 161.681 1024.51 167.777C1016.99 173.814 1008.44 178.608 998.854 182.159C989.266 185.71 978.761 187.486 967.338 187.486C950.825 187.486 936.65 183.698 924.813 176.122C913.035 168.546 904.542 157.627 899.334 143.363C894.125 129.099 893.149 111.906 896.404 91.7827C899.659 72.3106 906.022 55.7978 915.491 42.2443C925.02 28.6316 936.591 18.3037 950.204 11.2606C963.876 4.21756 978.495 0.696016 994.06 0.696016C1004.89 0.696016 1014.69 2.17566 1023.45 5.13494C1032.21 8.09422 1039.66 12.4148 1045.82 18.0966C1052.03 23.7192 1056.71 30.6143 1059.85 38.782C1062.98 46.9496 1064.34 56.3009 1063.93 66.8359ZM1089.99 34.8757L1095.31 3.18181H1244.64L1239.31 34.8757H1183.65L1158.79 185H1120.79L1145.65 34.8757H1089.99Z"
            fill="white"
            fillOpacity="0.1"
          />
        </svg>
      </div>
      <div className="me-svg">
        <svg
          width="611"
          height="291"
          viewBox="0 0 611 291"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M48.3977 0.0909004H124.25L172.119 195.545H175.528L287.886 0.0909004H363.739L315.443 291H255.784L287.318 101.653H284.761L178.511 289.58H137.744L93.9943 100.943H91.5795L59.7614 291H0.102273L48.3977 0.0909004ZM366.118 291L414.413 0.0909004H610.436L601.913 50.8011H467.396L456.033 120.119H580.464L571.942 170.83H447.51L436.146 240.29H571.232L562.709 291H366.118Z"
            fill="white"
            fillOpacity="0.1"
          />
        </svg>
      </div>
    </section>
  )
}

export default Contact
